import { render, staticRenderFns } from "./QrIdentityCode.vue?vue&type=template&id=53116eb0&scoped=true"
import script from "./QrIdentityCode.vue?vue&type=script&lang=js"
export * from "./QrIdentityCode.vue?vue&type=script&lang=js"
import style0 from "./QrIdentityCode.vue?vue&type=style&index=0&id=53116eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53116eb0",
  null
  
)

export default component.exports